module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/upload-icon-2597ce9ab8bd36863133eaa9bcc51ee3.png";